import React from "react"
import styled from "styled-components"
import Section from "../Section"
import CardContainer from "../CardContainer"
import TeamMember from "../TeamMember"

const StyledSection = styled(Section)`
  h2,
  h3 {
    text-transform: uppercase;
  }
  h3 {
    text-align: left;
  }
`

const StyledCardContainer = styled(CardContainer)`
  display: block;

  ${(props) => props.theme.media.tablet_landscape_up`
    display: grid;
  `}
`

function TeamMemberList({ team_members, append, ...props }) {
  return (
    <>
      <StyledSection color="primary" left={<h2>TEAM</h2>}>
        <StyledCardContainer columns="1fr 1fr 1fr">
          {team_members.map((member_) => {
            const { team_member: member } = member_
            return (
              <TeamMember
                content={member}
                fluid={member.imageSharp.childImageSharp.fluid}
                alt={member.image.alt}
              />
            )
          })}
        </StyledCardContainer>
      </StyledSection>
    </>
  )
}

export default TeamMemberList
